var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollobration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.813,
    height: 38.582,
    viewBox: "0 0 45.813 38.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1976.947,3144.639H1967.1a1.374,1.374,0,0,0-1.372,1.372v.812a1.373,1.373,0,0,0,1.372,1.372h9.956a1.373,1.373,0,0,0,1.372-1.372v-.812a1.374,1.374,0,0,0-1.372-1.372Z",
    transform: "translate(-1949.862 -3116.852)",
    fill: "#869dd2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2811.962,2063.325v-5.267a2.626,2.626,0,0,0-2.626-2.626h-3.383a2.59,2.59,0,0,0-1.182.284.375.375,0,0,1-.364-.005l-5.339-3.164a.381.381,0,0,1-.178-.247l-1.117-5.137a1.269,1.269,0,0,0-1.511-.973,1.241,1.241,0,0,0-.737.472,1.266,1.266,0,0,0-.233,1.038l1.27,5.842a1.264,1.264,0,0,0,.593.822l5.985,3.549a.381.381,0,0,1,.187.328v5.427a.527.527,0,0,0,.527.527h7.24A.87.87,0,0,0,2811.962,2063.325Z",
    transform: "translate(-2768.464 -2032.852)",
    fill: "#c3bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2023.54,2828.023v.813a1.362,1.362,0,0,0,.8,1.244h9.566a1.362,1.362,0,0,0,.8-1.244v-.813a1.373,1.373,0,0,0-1.372-1.371h-8.433A1.373,1.373,0,0,0,2023.54,2828.023Z",
    transform: "translate(-2006.913 -2803.056)",
    fill: "#869dd2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.445,
    cy: 4.445,
    rx: 4.445,
    ry: 4.445,
    transform: "translate(34.735 12.776)",
    fill: "#c3bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755.24,2119.521a2.419,2.419,0,0,1,1.845.249,1.9,1.9,0,1,1,1.077,2.806,2.406,2.406,0,0,1-1.2,1.418,3.632,3.632,0,0,0,1.7.439.248.248,0,0,1,.033-.006.4.4,0,0,1,.086,0,3.681,3.681,0,1,0-3.542-4.91Z",
    transform: "translate(-1742.149 -2102.824)",
    fill: "#869dd2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2671.511,1484.9a2.028,2.028,0,0,1,3.266.795,4.065,4.065,0,1,0-3.266-.795Zm2.507-5.481a2.286,2.286,0,1,1-2.286,2.286A2.289,2.289,0,0,1,2674.018,1479.415Z",
    transform: "translate(-2644.808 -1471.82)",
    fill: "#869dd2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.457,3472.667v1.84a.4.4,0,0,0,.4.4h44.854a.4.4,0,0,0,.4-.4v-1.84a.4.4,0,0,0-.4-.4H773.861a.4.4,0,0,0-.4.4Z",
    transform: "translate(-773.306 -3440.158)",
    fill: "#c3bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.153,3734.033h40.34a.4.4,0,0,0,.4-.4v-2.26a.4.4,0,0,0-.4-.4h-40.34a.4.4,0,0,0-.4.4v2.26A.4.4,0,0,0,945.153,3734.033Z",
    transform: "translate(-942.34 -3695.451)",
    fill: "#c3bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.49,2679.73v-.812a2.133,2.133,0,0,1,.975-1.791.346.346,0,0,0,.1-.47,2.122,2.122,0,0,1-.316-1.118v-.813a2.116,2.116,0,0,1,.378-1.208.375.375,0,0,0,.069-.244c-.017-.2-.048-.6-.07-.867a.346.346,0,0,0-.293-.319,4.363,4.363,0,0,1-1.958-.781l-8.891,4.024a.468.468,0,0,0-.275.426v4.474a.87.87,0,0,0,.87.87h9.908A2.125,2.125,0,0,1,1138.49,2679.73Z",
    transform: "translate(-1123.388 -2649.759)",
    fill: "#c3bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.311,1896.289l10.092-4.568a1.654,1.654,0,0,0,.966-1.4,1.612,1.612,0,0,0-.142-.781,1.655,1.655,0,0,0-2.186-.824l-7.426,3.363a.381.381,0,0,1-.51-.491l2.781-6.843a.381.381,0,1,1,.706.287l-2.422,5.958,6.041-2.736a4.477,4.477,0,0,1,3.138-3.4l-.242-.81a3.007,3.007,0,0,0-2.9-1.7h-4.519a3.58,3.58,0,0,0-3.332,2.249l-4.224,10.464a1.648,1.648,0,0,0,.384,1.813,1.682,1.682,0,0,0,1.826.313l1.952-.883Z",
    transform: "translate(-762.006 -1871.192)",
    fill: "#c3bedd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.207,
    cy: 5.207,
    rx: 5.207,
    ry: 5.207,
    transform: "translate(5.335)",
    fill: "#c3bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2399.976,1857.216a.636.636,0,0,1-.635-.635v-12.707a.635.635,0,0,1,1.27,0v12.707A.636.636,0,0,1,2399.976,1857.216Z",
    transform: "translate(-2377.761 -1832.604)",
    fill: "#869dd2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollobration);
export default __webpack_public_path__ + "static/media/collobration.450771c922efa80936b0528b323d0e39.svg";
export { ForwardRef as ReactComponent };